import React from "react";
import { Modal, Form, Button } from "react-bootstrap";

const SendAllNotificationModal = ({
  show,
  handleClose,
  handleSendAllNotification,
  handleChange,
  sendAllNotificationData,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Send Notification to All Users</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Notification ID</Form.Label>
            <Form.Control
              type="text"
              name="notificationId"
              value={sendAllNotificationData.notificationId}
              onChange={handleChange}
              placeholder="Enter Notification ID"
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSendAllNotification}>
          Send to All
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendAllNotificationModal;
